import React, { ReactElement } from 'react';
import { Modal } from '@odin-labs/components';
import { useJobsiteArchiveInvitationMutation } from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { TrashIcon } from 'components/icons';
import { AlertService } from 'components/alertService';
import { RemoveOnboardingLinkModalProps } from './types';

export function RemoveOnboardingLinkModal(
  props: RemoveOnboardingLinkModalProps,
): ReactElement {
  const { isOpen, jobsiteInvitationId, closeModal, onClosed, onConfirm } =
    props;

  const [jobsiteArchiveInvitation, { loading }] =
    useJobsiteArchiveInvitationMutation({
      onCompleted: (): void => {
        AlertService.alert(
          'success',
          'Success',
          'Worker onboarding link successfully removed',
        );
        onConfirm();
      },
      onError: (err): void => {
        AlertService.alert(
          'danger',
          'Something went wrong!',
          getGraphQLError(err),
        );
      },
      variables: { input: { jobsiteInvitationId } },
    });

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      size="sm"
      title="Delete this worker onboarding link?"
      titleAlignment="center"
      text={`After deletion workers won't be able to register using this link.`}
      textAlignment="center"
      onAction={jobsiteArchiveInvitation}
      actionText="Delete worker onboarding link"
      actionButtonTheme="danger"
      actionIcon={TrashIcon}
      actionButtonWithSpinner={loading}
    />
  );
}
